import React, { useEffect, useState } from 'react';
import {
  Form,
  Table,
  Input,
  Select,
  Button,
  Space,
  Tag,
  Modal,
  message,
  Tabs,
  Drawer,
  Checkbox,
} from 'antd';
import moment from 'moment';
import {
  getUserList,
  updateUserRole,
  getRoleList,
  getEndUserList,
  getUserLog,
  createUser,
  getCompanyList,
  createCompanyUser,
  updateSystemUser,
  deleteCompanyUser,
} from '../services/userService.js';
import { LockOutlined } from '@ant-design/icons';
import { adminChangePassword } from "../services/auth.js";
import RoleConfig from './RoleConfig.jsx';
import logIcon from '../assets/log.svg';
import ResponsiveFilterContainer from '../components/common/ResponsiveFilterContainer.jsx';
import { useGlobalState } from '../hooks/useGlobalState.js'
const UserList = () => {
  const [form] = Form.useForm();
  const [createUserForm] = Form.useForm();
  const [createCompanyUserForm] = Form.useForm();
  const [data, setData] = useState({ rows: [], total: 0 });
  const [logData, setLogData] = useState({ rows: [], total: 0 });
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [sorter, setSorter] = useState({ orderByColumn: '', isAsc: '' });
  const [isRoleConfigModal, setIsRoleConfigModal] = useState(false);
  const [editModal, setEditUserModal] = useState(false);
  const [originalUserName, setOriginalUserName] = useState({});
  const [originalUserStatus, setOriginalUserStatus] = useState({});
  const [userData, setUserData] = useState({});
  const [companyUserData, setCompanyUserData] = useState({});
  const [roles, setRoles] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [tabFlag, setTabFlag] = useState(1);
  const [isLogCenterOpen, setIsLogCenterOpen] = useState(false);
  const [createUserModal, setCreateUserModal] = useState(false);
  const [createCompanyUserModal, setCreateCompanyUserModal] = useState(false);
  const [logPagination, setLogPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const { userProfile } = useGlobalState();
  const userTag =userProfile?.user?.userStatus;
  const [editSystemUserModal, setEditSystemUserModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [recordDel, setRecordDel] = useState({});

  useEffect(() => {
    if (tabFlag == 2) {
      const companyResponse = getCompanyList();
      setCompanies(companyResponse.rows);
    }

  }, []);
  const hiddenColumnsForCompanyUser = [
    "companyName",
    "roleName",
  ];
  const columnsSystemUsers = [
    {
      title: 'Key',
      dataIndex: 'key',
      key: 'key',
      width: 80,
    },
    {
      title: 'User email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'SSO Plaform',
      dataIndex: 'source',
      key: 'source',
      render: (source) => {
        if (!source) {
          return '-';
        }
        if (source.length > 0 && source[0] !== source[0].toUpperCase()) {
          return source[0].toUpperCase() + source.slice(1);
        }
        return source;
      },
    },
    {
      title: 'Username',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Company',
      dataIndex: 'companyName',
      key: 'companyName',
      render: (companyName) => {
        if (!companyName) {
          return '-';
        }
        return companyName;
      },
    },
    {
      title: 'User role',
      dataIndex: 'roleName',
      key: 'roleName',
    },
    {
      title: 'User status',
      dataIndex: 'userStatus',
      key: 'userStatus',
    },
    {
      title: 'Quota',
      dataIndex: 'quota',
      key: 'quota',
      render: (_, record) => record.quota + '/' + record.rolesTokenCount,
    },
    {
      title: 'Message Count',
      dataIndex: 'messageCount',
      key: 'messageCount',
      sorter: false,
    },
    {
      title: 'Registration Time',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt) =>
        createdAt ? moment(createdAt).format('YYYY-MM-DD HH:mm:ss') : '-',
      sorter: true,
    },
    {
      title: 'Last Login Time',
      dataIndex: 'lastLoginTime',
      key: 'lastLoginTime',
      render: (lastLoginTime) =>
        lastLoginTime
          ? moment(lastLoginTime).format('YYYY-MM-DD HH:mm:ss')
          : '-',
      sorter: true,
    },
    {
      title: 'Login Count',
      dataIndex: 'loginCount',
      key: 'loginCount',
      sorter: true,
    },
    {
      title: 'Token Count',
      dataIndex: 'tokenCount',
      key: 'tokenCount',
      sorter: true,
    },
    {
      title: 'Account Status',
      key: 'accountStatus',
      dataIndex: 'accountStatus',
      render: (accountStatus) => {
        if (accountStatus === 0) {
          return <Tag color="error">Disable</Tag>;
        } else {
          return <Tag color="success">Enable</Tag>;
        }
      },
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 80,

      render: (record) => (
        <div style={{ width: '80px' }}>
          <Space size="small">
            <Button type="link" onClick={() => handleUserConfig(record)}>
              Edit
            </Button>
          </Space>
        </div>
      ),
    },
  ].filter(col => !(userTag === "Company User" && hiddenColumnsForCompanyUser.includes(col.dataIndex)));
  const columnsEndUsers = [
    {
      title: 'User ID',
      dataIndex: 'key',
      key: 'key',
      width: 80,
    },
    {
      title: 'User Name',
      dataIndex: 'nickName',
      key: 'nickName',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'User status',
      dataIndex: 'userStatus',
      key: 'userStatus',
    },
    {
      title: 'Company',
      dataIndex: 'companyName',
      key: 'companyName',
      render: (companyName) => {
        if (!companyName) {
          return '-';
        }
        return companyName;
      },
    },
    {
      title: 'AccountStatus',
      key: 'status',
      dataIndex: 'status',
      render: (status) => {
        if (status === '0') {
          return <Tag color="error">Disable</Tag>;
        } else {
          return <Tag color="success">Enable</Tag>;
        }
      },
    },
    {
      title: 'Create Time',
      dataIndex: 'createTime',
      key: 'createTime',
    },
    {
      title: 'Last Login Time',
      dataIndex: 'loginDate',
      key: 'loginDate',
      render: (loginDate) =>
        loginDate ? moment(loginDate).format('YYYY-MM-DD HH:mm:ss') : '-',
      sorter: true
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 80,

      render: (record) => (
        <div style={userTag === "Company User" ? { width: '80px' } : { width: '120px' }}>
          <Space size="small">
            <Button type="link" onClick={() => handleUserConfig(record)}>
              Edit
            </Button>
            {
              userTag === "Login User" && "Login User" !== record.userStatus &&
              <Button danger type="link" onClick={() => showModal(record)}>
                Delete
              </Button>
            }
          </Space>
        </div>
      ),
    },
  ].filter(col => !(userTag === "Company User" && col.dataIndex === 'companyName'));
  const handleLogTableChange = (logPagination) => {
    setLogPagination({
      current: logPagination.current,
      pageSize: logPagination.pageSize,
    });
    fetchLog({
      current: logPagination.current,
      pageSize: logPagination.pageSize,
    });
  };

  const fetchLog = async (pagination) => {
    try {
      setIsLogCenterOpen(true);
      const response = await getUserLog({
        pageNum: pagination.current,
        pageSize: pagination.pageSize,
        tabFlag: tabFlag,
        companyId: userProfile?.user?.companyId,
      });
      setLogData({
        rows: response.rows || [],
        total: response.total || 0,
      });
    } catch (error) {
      console.error('Fetch log error:', error);
    }
  };
  const logColumns = [
    {
      title: 'User',
      dataIndex: ['userMap', 'user'],
      key: 'userMap_user',
      width: 200,
      render: (_, record) => record.userMap?.user || '-',
    },
    {
      title: 'Operation',
      dataIndex: ['userMap', 'operation'],
      key: 'userMap_operation',
      width: 200,
      render: (_, record) => record.userMap?.operation || '-',
    },
    {
      title: 'Operator',
      dataIndex: ['userMap', 'operName'],
      key: 'userMap_operName',
      width: 200,
      render: (_, record) => record.userMap?.operName || '-',
    },
    {
      title: 'Operation Time',
      dataIndex: ['userMap', 'operTime'],
      key: 'userMap_operTime',
      width: 200,
      render: (_, record) => {
        const operTimeStr = record.userMap?.operTime;
        if (!operTimeStr) return '-';
        const utcString = operTimeStr.replace(' ', 'T') + 'Z';
        const date = new Date(utcString);
        return date.toLocaleString();
      },
    },
    {
      title: 'Result',
      dataIndex: ['userMap', 'result'],
      key: 'userMap_result',
      width: 200,
      render: (_, record) => {
        const result = record.userMap?.result || '-';
        const color =
          result == 'Success'
            ? 'green'
            : result == 'Failure'
              ? 'red'
              : 'inherit';
        return <span style={{ color }}>{result}</span>;
      },
    },
  ];
  useEffect(() => {
    fetchRoles();
  }, []);

  useEffect(() => {
    fetchUsers();
  }, []);
  const fetchUsers = async (
    params = filters,
    newPagination = pagination,
    newSorter = sorter
  ) => {
    setLoading(true);
    const companyId = params.company ?? userProfile?.user?.companyId ?? null;
    try {
      (tabFlag === 1 ? getUserList : getEndUserList)({
        searchValue: params.searchValue,
        roleId: params.role,
        ...(tabFlag === 1 ? { accountStatus: params.accountStatus } : { status: params.accountStatus }),
        userStatus: params.userStatus,
        pageNum: newPagination.current,
        pageSize: newPagination.pageSize,
        orderByColumn: newSorter.orderByColumn,
        isAsc: newSorter.isAsc,
        tabFlag: tabFlag,
        companyId: companyId,
      }).then((response) => {
        if (response?.code === 200) {
          const rows = response.rows.map((item, index) => ({
            key:
              (newPagination.current - 1) * newPagination.pageSize + index + 1,
            ...item,
          }));
          setData({ rows, total: response.total });
        }
      });
    } catch (error) {
      console.error('Failed to fetch user list:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (values) => {
    if (
      !values.searchValue &&
      !values.userStatus &&
      values.accountStatus === undefined &&
      !values.role &&
      !values.company
    ) {
      return handleReset();
    }

    setFilters(values);
    setPagination({ ...pagination, current: 1 });
    fetchUsers(values, pagination, sorter);
  };

  const handleReset = () => {
    form.resetFields();
    setFilters({});
    const newPagination = { current: 1, pageSize: 10 };
    setPagination({ current: 1, pageSize: 10 });
    setSorter({ orderByColumn: '', isAsc: '' });
    fetchUsers({}, newPagination);
  };

  const handleTableChange = (pagination, tableFilters, sorter) => {
    const newSorter = {
      orderByColumn: sorter.columnKey ? mapSortField(sorter.columnKey) : '',
      isAsc:
        sorter.order === 'ascend'
          ? 'ASC NULLS LAST'
          : sorter.order === 'descend'
            ? 'DESC NULLS LAST'
            : '',
    };

    setPagination({
      current: pagination.current,
      pageSize: pagination.pageSize,
    });
    setSorter(newSorter);
    fetchUsers(filters, pagination, newSorter);
  };

  const mapSortField = (columnKey) => {
    const mapping = {
      tokenCount: 'u.tokenCount',
      loginCount: 'l.loginCount',
      lastLoginTime: 'l.lastLoginTime',
      createdAt: 'u.createdAt',
    };
    return mapping[columnKey] || columnKey;
  };

  const handleRoleConfig = () => {
    setIsRoleConfigModal(true);
  };

  const handleUserConfig = (record) => {

    if (tabFlag === 1) {
      setEditUserModal(true);
      setUserData(record);
    } else {
      setEditSystemUserModal(true);
      setCompanyUserData(record);
    }
  };

  const handleUserDelete = () => {
    if (loading) return;
    const userStatus = recordDel.userStatus;
    if('Login User' === userStatus){
      message.error('Only company users can be deleted..');
    }else{
      try {
        setLoading(true);
        deleteCompanyUser({
          userId: recordDel.userId,
          name: recordDel.userName,
          logContent:
              'Delete Company User userName:' +
              recordDel.userName
        }).then((response) => {
            if (response && response.code === 200) {
              fetchUsers();
              message.success('Company User delete successfully');
              handleReset();
            } else {
              message.error(response.msg);
            }
          });
        setIsModalOpen(false);
      } catch (error) {
        message.error('delte error.');
      } finally {
        setLoading(false);
      }
    }
  };

  const showModal = (record) => {
    setIsModalOpen(true);
    setRecordDel(record);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleEditUserCancel = () => {
    setOriginalUserName({});
    setOriginalUserStatus({});
    setEditUserModal(false);
  };

  const handleEditSystemUserCancel = () => {
    setOriginalUserStatus({});
    setEditSystemUserModal(false);
  };

  //update System Admins
  const handleEditUserOk = () => {
    if (loading) return;
    setLoading(true);
    let content = '';
    const oldRoleName = originalUserName.roleName;
    const oldAccountStatus = originalUserStatus.accountStatus;
    const newRoleName = userData.roleName;
    const newAccountStatus = userData.accountStatus;
    if (
      oldRoleName != undefined &&
      newRoleName != undefined &&
      oldRoleName != newRoleName
    ) {
      content =
        content + 'Role Name from ' + oldRoleName + ' to ' + newRoleName + ';';
    }
    if (
      oldAccountStatus != undefined &&
      newAccountStatus != undefined &&
      oldAccountStatus != newAccountStatus
    ) {
      content =
        content +
        'Account Status from ' +
        (oldAccountStatus == 0 ? 'Disable' : 'Enable') +
        ' to ' +
        (newAccountStatus == 0 ? 'Disable' : 'Enable') +
        ';';
    }
    updateUserRole({
      id: userData.id,
      userId: userData.userId,
      roleId: userData.roleId,
      accountStatus: userData.accountStatus,
      name: userData.name,
      logContent: content,
    })
      .then((response) => {
        if (response && response.code == 200) {
          message.success('Update successful');
          fetchUsers();
        } else {
          message.error('Update failed');
        }
      })
      .catch((error) => {
        console.error('Failed to save role:', error);
        message.error('Failed to save role:');
      })
      .finally(() => {
        setLoading(false);
        setOriginalUserName({});
        setOriginalUserStatus({});
        setEditUserModal(false);
      });
  };

  //update System Admins
  const handleEditSystemUserOk = () => {
    if (loading) return;
    setLoading(true);
    let content = '';
    const oldAccountStatus = originalUserStatus.status;
    const newAccountStatus = companyUserData.status;

    if (
      oldAccountStatus != undefined &&
      newAccountStatus != undefined &&
      oldAccountStatus != newAccountStatus
    ) {
      content =
        content +
        'Account Status from ' +
        (oldAccountStatus == 0 ? 'Disable' : 'Enable') +
        ' to ' +
        (newAccountStatus == 0 ? 'Disable' : 'Enable') +
        ';';
    }
    updateSystemUser({
      userId: companyUserData.userId,
      accountStatus: companyUserData.status,
      userStatus: companyUserData.userStatus,
      name: companyUserData.userName,
      logContent: content,
    })
      .then((response) => {
        if (response && response.code == 200) {
          message.success('Update successful');
          fetchUsers();
        } else {
          message.error('Update failed');
        }
      })
      .catch((error) => {
        console.error('Failed to save role:', error);
        message.error('Failed to save role:');
      })
      .finally(() => {
        setLoading(false);
        setOriginalUserStatus({});
        setEditSystemUserModal(false);
      });
  };

  const fetchRoles = async () => {
    try {
      const response = await getRoleList();
      setRoles(response.rows);

      const companyResponse = await getCompanyList();
      setCompanies(companyResponse.rows);
    } catch (error) {
      console.error('Failed to fetch roles:', error);
    }
  };
  const closeDrawer = () => {
    setIsLogCenterOpen(false);
    setLogPagination({ current: 1, pageSize: 10 });
  };

  const onChange = (key) => {
    setTabFlag(key);
    form.resetFields();
    setFilters({});
    setSorter({ orderByColumn: '', isAsc: '' });
    setPagination({ current: 1, pageSize: 10 });
  };

  const cancelCreateUser = () => {
    setCreateUserModal(false);
    createUserForm.resetFields();
  };
  const cancelCreateCompanyUser = () => {
    setCreateCompanyUserModal(false);
    createCompanyUserForm.resetFields();
  };

  const handleCreateUser = () => {
    if (loading) return;
    setLoading(true);
    createUserForm
      .validateFields(['userName', 'userEmail', 'roleId', 'allowEmail'])
      .then((values) => {
        let roleName = '';
        const { userName, userEmail, roleId, allowEmail } = values;
        const role = roles.find((role) => role.roleId === roleId);
        if (role) {
          roleName = role.roleName;
        }
        createUser({
          name: userName,
          email: userEmail,
          roleId: roleId,
          userStatus: allowEmail ? 'Email User' : 'Login User',
          logContent:
            'Add User userName:' +
            userName +
            ',userEmail:' +
            userEmail +
            ',roleName:' +
            roleName +
            ',allowEmail:' +
            allowEmail,
        })
          .then((response) => {
            cancelCreateUser();
            if (response && response.code === 200) {
              message.success('User created successfully');
              handleReset();
            } else {
              message.error(response.msg);
            }
          })
          .catch((error) => {
            console.error('Failed to create user:', error);
            message.error('Failed to create user');
            cancelCreateUser();
          });
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
        cancelCreateUser();
      });
  };
  const handleCreateCompanyUser = () => {
    if (loading) return;
    setLoading(true);
    createCompanyUserForm
      .validateFields(['userName', 'userEmail', 'company'])
      .then((values) => {
        let companyName = '';
        const { userName, userEmail, company } = values;
        const companyObj = companies.find((companyObj) => companyObj.id === company);
        if (companyObj) {
          companyName = companyObj.companyName;
        }
        createCompanyUser({
          name: userName,
          email: userEmail,
          companyId: company,
          logContent:
            'Add Company User userName:' +
            userName +
            ',userEmail:' +
            userEmail +
            ',companyName:' +
            companyName
        })
          .then((response) => {
            cancelCreateCompanyUser();
            if (response && response.code === 200) {
              message.success('Company User created successfully');
              handleReset();
            } else {
              message.error(response.msg);
            }
          })
          .catch((error) => {
            console.error('Failed to create company user:', error);
            message.error('Failed to create company user');
            cancelCreateCompanyUser();
          })
          .finally(()=>{
            setLoading(false);
          });
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
        cancelCreateCompanyUser();
      });
  };
  const adminResetPassword = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const response = await adminChangePassword(companyUserData.email);
      if (response.code === 200) {
        message.success('Password updated');
      } else {
        message.error(response.msg || 'Password update failed');
      }
    } catch {
      message.error('Password update failed');
    } finally {
      setLoading(false);
      handleEditSystemUserCancel();
    }
  }
  useEffect(() => {
    handleSearch(filters);
  }, [tabFlag]);

  const items = [
    {
      key: 1,
      label: 'Users',
      children: '',
    },
    {
      key: 2,
      label: 'System Admins',
      children: '',
    },
  ];

  return (
    <div>
      <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
      <div>
        <ResponsiveFilterContainer
          form={form}
          onSearch={handleSearch}
          onReset={handleReset}
          initialValues={{
            searchValue: '',
            userStatus: '',
            accountStatus: undefined,
            role: '',
            company: '',
          }}
          extraButtons={
            <>
              {tabFlag === 1 && userTag !== "Company User" && (
                <Button type="primary" onClick={() => handleRoleConfig()}>
                  Quota Setting
                </Button>
              )}
              {tabFlag === 1 && userTag !== "Company User" && (
                <Button type="primary" onClick={() => setCreateUserModal(true)}>
                  Create User
                </Button>)}
              {tabFlag === 2 && userTag !== "Company User" && (
                <Button type="primary" onClick={() => setCreateCompanyUserModal(true)}>
                  Create Company User
                </Button>
              )}
              <Button
                type="text"
                icon={
                  <img
                    src={logIcon}
                    alt="log"
                    style={{ width: 30, height: 30 }}
                  />
                }
                onClick={() => fetchLog(logPagination)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 0,
                  border: 'none',
                  background: 'none',
                  boxShadow: 'none',
                }}
              />

            </>
          }
        >
          <Form.Item name="searchValue">
            <Input
              placeholder="Please enter content to search"
              style={{ width: '100%' }}
            />
          </Form.Item>
          {userTag !== "Company User" && (
            <Form.Item name="company" label="Company">
              <Select
                style={{ width: '100%' }}
                options={companies.map((company) => ({
                  label: company.companyName,
                  value: company.id,
                }))}
              ></Select>
            </Form.Item>
          )}
          {tabFlag === 1 && (
            <Form.Item name="userStatus" label="User status">
              <Select
                style={{ width: '100%' }}
                options={[
                  { value: 'Login User', label: 'Login User' },
                  {
                    value: 'Not Logged-in User',
                    label: 'Not Logged-in User',
                  },
                  { value: 'Email User', label: 'Email User' },
                ]}
              />

            </Form.Item>
          )}
          {tabFlag === 2 && userTag !== "Company User" && (
            <Form.Item name="userStatus" label="User status">
              <Select
                style={{ width: '100%' }}
                options={[
                  { value: 'Login User', label: 'Login User' },
                  { value: 'Company User', label: 'Company User' },
                ]}
              />

            </Form.Item>
          )}
          <Form.Item name="accountStatus" label="Account Status">
            <Select
              style={{ width: '100%' }}
              options={[
                { value: 1, label: 'Enable' },
                { value: 0, label: 'Disable' },
              ]}
            />
          </Form.Item>
          {tabFlag === 1 && (
            <>
              {userTag !== "Company User" && (
                <Form.Item name="role" label="Role">
                  <Select
                    style={{ width: '100%' }}
                    options={roles.map((role) => ({
                      label: role.roleName,
                      value: role.roleId,
                    }))}
                  ></Select>
                </Form.Item>
              )}
            </>
          )}
        </ResponsiveFilterContainer>

        <Table
          columns={tabFlag === 1 ? columnsSystemUsers : columnsEndUsers}
          dataSource={data.rows}
          loading={loading}
          pagination={{
            current: pagination.current,
            total: data.total,
            pageSize: pagination.pageSize,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total) => `${total} in total`,
          }}
          onChange={handleTableChange}
          scroll={{ x: 'max-content' }}
        />
        <RoleConfig
          visible={isRoleConfigModal}
          onCancel={() => {
            setIsRoleConfigModal(false);
          }}
          afterClose={() => {
            fetchRoles();
            handleReset();
          }}
        />
        <Modal
          title="Edit"
          open={editModal}
          onCancel={handleEditUserCancel}
          footer={[
            <div
              key="footer"
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '20px',
              }}
            >
              <Button key="back" onClick={handleEditUserCancel}>
                Cancel
              </Button>
              <Button key="submit" type="primary" onClick={handleEditUserOk} loading={loading}>
                Save
              </Button>
            </div>,
          ]}
        >
          <div style={{ padding: 20 }}>
            <div style={{ padding: 10 }}>User name: {userData.name}</div>
            <div style={{ padding: 10 }}>User email: {userData.email}</div>
            <div style={{ padding: 10 }}> SSO plaform: {userData.source}</div>
            {userTag !== "Company User" && <div style={{ padding: 10 }}> Company: {userData.companyName ?? "-"}</div>}
            {userTag !== "Company User" && <div style={{ padding: 10 }}>
              User role:
              <Select
                value={userData.roleName}
                style={{ width: 200 }}
                onChange={(value) => {
                  setOriginalUserName({
                    ...userData,
                    roleId: userData.roleId,
                    roleName: userData.roleName,
                  });
                  const selectedRole = roles.find(
                    (role) => role.roleId === value
                  );
                  if (selectedRole) {
                    setUserData({
                      ...userData,
                      roleId: value,
                      roleName: selectedRole.roleName,
                    });
                  }
                }}
                options={roles.map((role) => ({
                  label: role.roleName,
                  value: role.roleId,
                }))}
              ></Select>
            </div>}
            <div style={{ padding: 10 }}>
              Account status:
              <Select
                value={userData.accountStatus}
                style={{ width: 200 }}
                onChange={(value) => {
                  setOriginalUserStatus({
                    ...userData,
                    accountStatus: userData.accountStatus,
                  });
                  setUserData({ ...userData, accountStatus: value });
                }}
                options={[
                  { value: 1, label: 'Enable' },
                  { value: 0, label: 'Disable' },
                ]}
              ></Select>
            </div>
          </div>
        </Modal>

        <Modal
          title="System Admins"
          open={editSystemUserModal}
          onCancel={handleEditSystemUserCancel}
          footer={[
            <div
              key="footer"
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '20px',
              }}
            >
              <Button key="back" onClick={handleEditSystemUserCancel}>
                Cancel
              </Button>
              <Button key="submit" type="primary" onClick={handleEditSystemUserOk} loading={loading}>
                Save
              </Button>
            </div>,
          ]}
        >
          <div style={{ padding: 20 }}>
            <div style={{ padding: 10 }}>User name: {companyUserData.nickName}</div>
            <div style={{ padding: 10 }}>User email: {companyUserData.email}</div>
            <div style={{ padding: 10 }}>
              Account status:
              <Select
                value={companyUserData.status}
                style={{ width: 200 }}
                onChange={(value) => {
                  setOriginalUserStatus({
                    ...companyUserData,
                    status: companyUserData.status,
                  });
                  setCompanyUserData({ ...companyUserData, status: value });
                }}
                options={[
                  { value: '1', label: 'Enable' },
                  { value: '0', label: 'Disable' },
                ]}
              ></Select>
            </div>
            {companyUserData.userStatus === "Company User" && <div style={{ padding: 10, marginLeft: 100 }}>
              <Button type="primary" onClick={() => adminResetPassword()} loading={loading}>
                <LockOutlined style={{ marginRight: 8 }} />
                Reset Password
              </Button>
            </div>}

          </div>
        </Modal>
        <Modal
          title="Create Email User"
          open={createUserModal}
          onCancel={cancelCreateUser}
          onOk={handleCreateUser}
          confirmLoading={loading}
        >
          <Form
            form={createUserForm}
            labelCol={{ span: 6 }}
            style={{ paddingTop: 30 }}
            initialValues={{
              roleId: roles.find((r) => r.roleName === 'Freemium')?.roleId,
              allowEmail: true,
            }}
          >
            <Form.Item
              name="userName"
              label="User Name"
              rules={[{ required: true, message: 'Please enter user name' }]}
            >
              <Input placeholder="Enter user name" />
            </Form.Item>
            <Form.Item
              name="userEmail"
              label="User Email"
              rules={[
                { required: true, message: 'Please enter user email' },
                {
                  type: 'email',
                  message: 'Please enter a valid email address',
                },
              ]}
            >
              <Input placeholder="Enter user email" />
            </Form.Item>
            <Form.Item name="roleId" label="User Role">
              <Select
                style={{ width: '100%' }}
                options={roles.map((role) => ({
                  label: role.roleName,
                  value: role.roleId,
                }))}
              ></Select>
            </Form.Item>
            <Form.Item
              name="allowEmail"
              label="Allow Email"
              valuePropName="checked"
              style={{ display: 'none' }}
            >
              <Checkbox />
            </Form.Item>
          </Form>
        </Modal>
        <Modal
          title="Create Company User"
          open={createCompanyUserModal}
          onCancel={cancelCreateCompanyUser}
          onOk={handleCreateCompanyUser}
          confirmLoading={loading}
        >
          <Form
            form={createCompanyUserForm}
            labelCol={{ span: 6 }}
            style={{ paddingTop: 30 }}
          >
            <Form.Item
              name="userName"
              label="User Name"
              rules={[{ required: true, message: 'Please enter user name' }]}
            >
              <Input placeholder="Enter user name" />
            </Form.Item>
            <Form.Item
              name="userEmail"
              label="User Email"
              rules={[
                { required: true, message: 'Please enter user email' },
                {
                  type: 'email',
                  message: 'Please enter a valid email address',
                },
              ]}
            >
              <Input placeholder="Enter user email" />
            </Form.Item>
            <Form.Item name="company" label="Company">
              <Select
                style={{ width: '100%' }}
                options={companies ? companies.map((company) => ({
                  label: company.companyName,
                  value: company.id,
                })) : []}
              ></Select>
            </Form.Item>
          </Form>
        </Modal>
        <Drawer
          placement="right"
          width={'80%'}
          onClose={closeDrawer}
          open={isLogCenterOpen}
        >
          <Table
            rowKey="operId"
            columns={logColumns}
            dataSource={logData.rows}
            loading={loading}
            pagination={{
              total: logData.total,
              current: logPagination.current,
              pageSize: logPagination.pageSize,
              showSizeChanger: true,
              showQuickJumper: true,
              showTotal: (total) => `${total} in total`,
            }}
            scroll={{ x: 'max-content' }}
            onChange={handleLogTableChange}
          />
        </Drawer>

        <Modal
          title="Delete"
          open={isModalOpen}
          onOk={handleUserDelete}
          onCancel={handleCancel}
          confirmLoading={loading}
        >
          <p>Do you want to delete this user?</p>
        </Modal>
      </div>
    </div>
  );
};
export default UserList;
